import React from "react";

import Header from "../../components/header";
import HeaderMobile from "../../components/header-mobile";
import FormApplication from "../../components/form-application";

import { useScreenSize } from "../../hooks/useScreenSize";

import * as S from "./styles";

const SectionHero = () => {
  const dimension = useScreenSize();

  return (
    <S.SectionHero id="toRegister" data-section="section_hero">
      {dimension.width > 1024 && <Header></Header>}
      {dimension.width <= 1024 && <HeaderMobile></HeaderMobile>}
      <div className="overlay"></div>
      
      <div className="container">
        <div className="info-desktop">
          <span>
            Cadastre-se e acesse um universo completo com diversos conteúdos 
            para mandar bem na prova: jogo Expedição ENEMVERSO no Fortnite, 
            lives com Casimiro, ebooks, simulados, teste vocacional e tudo o que 
            você precisa para alcançar essa conquista.
          </span>
        </div>
        <FormApplication></FormApplication>
      </div>
      
    </S.SectionHero>
  );
};

export default SectionHero;
